module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER ONE")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("S"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HEIKH")]), _vm._v(" N"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ADIM")]), _vm._v(" B"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("IN")]), _vm._v(" K"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ALID AL")]), _vm._v(" S"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("AQR’S")])]), _vm._v(" dark eyes followed the horse and rider as they exercised on the gallops. He was blinded not only by the sheer magnificence of the colt, which had quickened his pulse and sent a thrill of triumph through him as soon as he’d seen its exquisite lines, but also by the intense green of everything as far as the eye could see. Softly falling rain covered everything in a fine mist, even though it was an unseasonably warm September day.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For a man who considered himself hewn from the uncompromising aridity of mountains and desert, he hadn’t expected to feel a kinship with this inclement part of the world, but strangely, standing here now, he felt its lushness pull on his soul in a way he hadn’t anticipated.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Up until now he’d been content to confine his interest in thoroughbred racing and breeding to his home on the Arabian peninsula, trusting his aides to buy in Europe and transport the horses to him. But now it was time to set up a European base, and he’d chosen Kildare, the Irish capital of thoroughbred breeding and training.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page07"
    }
  }, [_vm._v("Ireland’s reputation as home to the world’s best horses, breeders and trainers was not in doubt. The man beside him, despite his florid appearance, which more than hinted at a drinking problem, had reputedly been one of the best ")]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("trainers in the world, but until very recently had all but disappeared from the racing world.")])]), _c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The silence grew taut but he didn’t speak for a few moments longer, unperturbed, studying the two-year-old.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His eyes drifted up from the horse to the rider. He could see that not only was the horse perhaps one of the most magnificent he’d seen in a long time, the rider too was one of the most accomplished he’d seen—and that included his own carefully handpicked staff back home. He looked to be about eighteen, slim build, definitely young. Yet he exuded an effortless way of handling the horse which Nadim knew only came from true talent, sheer courage and experience. And the animal was spirited.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man moved restlessly beside him and Nadim took pity, saying finally, ‘He’s a stunning colt.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes,’ Paddy O’Sullivan said with more than a hint of relief in his voice. ‘I was sure you’d see it straight away.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The horse they observed and spoke of was one of the main reasons for Nadim’s visit to Ireland, and the reason why he was about to buy Paddy O’Sullivan out of his failing modest-sized training grounds and stud farm.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It’d be hard not to see it,’ Nadim murmured, his eyes once again mesmerised by the sleek move of powerful muscles under the thoroughbred’s glossy coat. Already he was imagining the lineage that such a stallion and his brood mares could produce one day.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d sent his most senior equestrian aide to research this part of the world for him, and had instantly seen the potential; the stud was about two miles down the road from the house and training grounds. Perfect for his European base.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }, [_vm._v("His mouth firmed when he recalled how his aide had been all but run off the beleaguered property by some angry woman with a rabid dog—hence his advice to steer ")]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("well clear. But Nadim had made sure that his people had approached Paddy O’Sullivan directly and made an offer that no drowning man hoping for a life-raft could refuse…")])]), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The O’Sullivan stud had once been very successful, breeding numerous winners. It was that pure bloodline which had produced this colt, who was already making a name for itself, having won two of Ireland’s highest-profile flat races in recent months. Excitement kicked low in Nadim’s belly—a sensation he hadn’t felt in a long time—making him aware of how rarely spontaneous emotion impacted on his day-to-day life. Just the way he liked it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("O’Sullivan spoke again, ‘Iseult has been working with him tirelessly. He wouldn’t be the horse he is today without her.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nadim frowned and took his eyes off the horse for a moment to look down at the much shorter man beside him. He hadn’t heard that name before, and assumed it had to be of Irish origin. ‘Ee—sult?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man gestured with his white head to the field, blue eyes fond. ‘Iseult is my daughter—my eldest. She’s got the gift. Been able to communicate with and control every animal she’s encountered since she was barely walking.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nadim’s eyes went back to the rider on the horse. He felt slightly stunned. That was a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("girl")]), _vm._v("? And this "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("girl")]), _vm._v(" had trained this colt? Impossible; he’d worked with plenty of female trainers, but never one so young. Too young—no matter how innate her talent might be.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("He shook his head, mentally trying to take it in, and only then started to see the subtle differences. Her waist dipped in and out more than a boy’s should. The silhouette of her shoulders was slight, the hint of her neck delicate. Apart from that he couldn’t tell much else, because she was covered up in jeans and a fleece, hair tucked up and ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("under a flat cap. His belly clenched as he tasted the old fear when he realised belatedly that she wasn’t wearing a hard hat. He drove it down. This wasn’t Merkazad. The ground was soft here—not fatally hard.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But still she should be wearing adequate protection. A surge of irritation prickled across Nadim’s skin. If she was at "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("his")]), _vm._v(" stables right now she’d be seriously reprimanded for not wearing appropriate head protection.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("O’Sullivan said now, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sotto voce")]), _vm._v(", even though no one could overhear, ‘I’m sorry about what happened…with your assistant. Iseult’s not happy about the sale…of either our stud farm or Devil’s Kiss.’ He continued nervously, ‘She’s very attached to her home and her…’ The man blustered for a moment and corrected himself, ‘That is, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("your")]), _vm._v(" horse.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nadim’s blood started to boil ominously. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("This")]), _vm._v(" girl was the person who’d practically set a dog on his assistant Adil? This was intolerable. Where Nadim came from daughters were dutiful. Independent, yes, but not openly wilful and opinionated. And they weren’t trainers who looked to be barely out of their teens. He thanked his lucky stars that he’d come now. This girl, if left to her own devices, could have ruined all his chances for acquiring this property.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was clearly bent on obstructing a sale, and right now he wouldn’t put it past her to sabotage the horse he wanted so badly. He was well aware that the racing world was littered with great two-year-olds who peaked too early and never went on to achieve anything else.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Those thoughts made his voice more autocratic. ‘He is about to become mine, as is your property—unless of course you’ve changed your mind?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("O’Sullivan blustered and stuttered, ‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("No")]), _vm._v(", Sheikh Nadim. I never meant that at all. It’s just that Iseult has been training Devil’s Kiss…so she’s attached.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("Nadim flicked the man beside him a dark look, hiding ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("the fact that he was taken aback anew to hear it confirmed that she’d trained him. And he had to admit, despite his misgivings, that the horse looked good.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I would hope that the advantage of keeping the training grounds and stud in your name, along with being kept on as manager, is benefit enough compared to the alternative—which is that your bank is ready to throw you out on the street.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The older man was all but wringing his hands, clearly terrified he’d offended the new landlord. ‘Of course, Sheikh Nadim…I never meant to imply anything… It’s just that Iseult—well, she’s a bit headstrong. I hope that she doesn’t offend…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His voice trailed away as the rider slowed and came to a halt, turning the horse slowly to face where Nadim and Paddy O’Sullivan stood. Nadim watched as they approached, and the rider became more obviously a young girl. Just how old was she, anyway? he wondered as they drew closer and closer. It was impossible to tell.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He noted with increasing displeasure that she wasn’t jumping off the horse to make his acquaintance.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For some reason, when his attention should have been taken by the horse, he found his eye resting curiously on its rider, his thoughts staying on her. A face was partially revealed beneath the lip of the cap. And something in his chest kicked once. Like an electric shock to his heart.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He could see that her face was exquisitely sculped—high cheekbones and a delicately firm jaw, straight nose. Her eyes were hidden by the cap, and her mouth was set in a mutinous line, but Nadim imagined that in repose it would be sensuously full. His gaze dropped and he saw the unmistakable line of slight but feminine curves beneath her T-shirt. He felt another kick then, in a more base part of his anatomy, and was astounded.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He expected such responses when he moved in sophisticated circles where mature, experienced, sensually confident women abounded. Not here in a strange country, on the edge of a green field, looking at a girl he’d moments ago dismissed as a boy. And who was irritating him more with each passing minute. Anger at his own unbidden response made the muscles in his face tighten.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Iseult O’Sullivan had hated every minute of having to exercise Devil’s Kiss for the man who had come to inspect the spoils of his takeover—especially when he didn’t even care enough to see what he was buying himself before he came today to sign the deal.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d sent an assistant to trespass on their land and take photographs, after which he’d quietly bought the adjoining land some months previously. And since then he’d been biding his time, waiting to strike—like a vulture circling over a decaying carcass—until they’d had no choice but to announce the sale. But as she looked down now, her boiling anger seemed to drain away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was suddenly absurdly glad to be sitting astride Devil’s back, because she knew if she was standing she might not be able to remember why she was angry. Her hands gripped the reins and Devil’s Kiss moved restlessly underneath her, sensing her inner agitation, his highly strung nature never too far from the surface.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The man was like something from another planet, and nothing like the stereotypical Arabic Sheikh she might have imagined if she hadn’t already Googled him for information and seen pictures. And, despite having seen pictures of him, it was still hard for her to deal with the reality. He looked to be in his mid-thirties, and was as insanely good-looking as his pictures had promised. Tall, handsome, and dangerously dark.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He was wearing faded jeans which clung indecently to powerful thigh muscles, and a dark long-sleeved polo shirt, its sleeves rolled up to reveal muscled forearms. His biceps bulged against the material of his shirt, and the fine Irish mist settled over him like a glittering diamond coat. His darkly olive skin stood out against the lush backdrop like an exotic hothouse flower.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("One booted foot was lifted to rest negligently on the bottom rung of the fence. His hair was short and dark, but thick, as if it would lean towards unruly curls if allowed to grow any longer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She took in all this in a second, with an accelerating heartbeat. Virile sexuality drenched the air around him like a tangible forcefield and Iseult shivered involuntarily, recognising a base sexuality that seemed to resonate with something equally base within her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He carried an air of authority and power suited to the monarch he was, ruling over a wealthy sheikhdom where he owned one of the most exclusive thoroughbred stables on the Arabian peninsula. The kind of stables where legendary winners were bred and trained.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With her heart stuttering in her chest, Iseult watched as the Sheikh calmly and gracefully vaulted over the fence, not a hint of strain on his face even though the fence was over five feet. Immediately Devil’s head reared back, nostrils flaring, and he stepped sideways with a skittish move. Iseult patted the horse and murmured encouragement for him to not make this easy on his new owner.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("Her father, standing just a few feet away, was sending fervent silent signals to Iseult: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Please behave.")]), _vm._v(" But she was too heartsore to behave, no matter how she’d been momentarily thrown. This man was coolly and calmly taking everything she’d ever known and loved, and there ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("wasn’t a thing she could do about it except not make it easy for him.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The Sheikh was looking up at her, and she could see the expressions crossing his face, and his anger mounting that she wasn’t jumping off, jumping to attention. While she’d have liked to think that she was consciously making her displeasure known, she knew her inability to move had more to do with his sheer male charisma than any rebellion. Finally her father’s voice intruded, and she could hear the fear. ‘Iseult, please allow Sheikh Nadim to ride Devil’s Kiss. He’s come a long way.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With much less grace than she was used to Iseult slipped off the horse and came around his head to hand the reins to the Sheikh. Her legs turned to water when she recognised just how tall and well built he was. Like one long, lean and hardened muscle, with shoulders so broad they blocked out the background.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She felt innately feminine next to his superior build. It was very disturbing when she’d long ago given up any attempt to explore that side of herself, assuming she just didn’t have it in her. Reaction to her thoughts made her all but thrust the reins at him. ‘Here you are.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His black eyes glittered dangerously, and Iseult was glad of the protection of her cap. She desperately wanted him to take the reins before he could see how her hand was starting to shake, and to her intense relief he did. But not before his fingers touched off hers, and she jerked back so quickly that Devil’s Kiss moved skittishly again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Before she could lose it completely she turned and walked away through the soft damp grass, and climbed over the fence jerkily to stand by her father, who was radiating waves of disapproval. She’d never felt so out of control of her own body and emotions, and she didn’t like it one bit.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She watched with a thumping heart as Sheikh Nadim coolly and calmly walked around the horse, lengthening the stirrups and running a large brown hand over his flanks. Iseult’s belly tightened and she felt a flare of something hot in her abdomen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then he vaulted onto the horse with a fluid grace she’d never seen before, and nudged Devil’s Kiss straight into a canter. Iseult’s throat dried up completely. Devil’s Kiss was an absolute traitor; he’d shown not even a flicker of rebellion at seating this man, clearly recognising his skill and authority.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sheikh Nadim al Saqr was considered something of a rebel in horse breeding circles, as he’d been slow to set up a base in Europe, preferring to keep his horses in his home country, out of sight and highly secret. The world of flat racing had been sent into a tailspin when he’d entered one of his three-year-olds into the most prestigious race in Europe at Longchamp the previous year and it had won. A rank outsider, who had only raced previously in Dubai, it had stunned everyone and made the racing world sit up and recognise Sheikh Nadim al Saqr as a serious contender.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Beside her, her father chuckled softly and said, ‘Weren’t expecting Devil’s Kiss to take to him like that, were you?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The backs of Iseult’s eyes stung with hot tears, which was so unlike her—after everything she’d been through she rarely if ever resorted to tears, and suddenly she was a bag of weeping hormones. This was the ultimate betrayal, coming on top of everything else. With an incoherent grunt she turned and stormed off, back up the drive to the house they no longer owned, away from the field they also no longer owned.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("Her father hissed after her desperately, ‘Iseult O’Sullivan, ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("come back here right now. You cannot just walk away—what will he think?’")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Iseult turned, but kept walking backwards and flung her arms up. ‘We’ve lost everything, Dad—I’m not going to bow and scrape after that man. Let him take Devil’s Kiss back to the stables and scrub him down if he wants him so badly.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Years of looking after her father and her two younger brothers and sister had put her in a position of unspoken authority in their home. Even her father knew when not to push her; he owed her too much.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was only then that she noticed the sleek silver Jeep with dark windows and an officious-looking bodyguard standing to attention nearby, intermittently scanning the surroundings from behind black glasses. It made her even angrier, reminding her of the sheer arrogance of his pushy assistant, who’d had the gall to come and look the place over, as if it was a slave girl being sold at an auction, before they’d even publicly announced the sale.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Iseult turned and kept walking, tears blurring her vision. A part of her balked at her extremely uncharacteristic lack of grace and manners, but something about the Sheikh had all her defences raised high and on red alert. She simply couldn’t stand there and watch him steal her horse from right under her, and then deal with the undoubtedly arrogant and smug way he’d hand her back the reins as if she was nothing more than a stablehand.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("Iseult’s tears cleared as she fumed and stomped up the drive; that might be what he was used to in his own country but he wouldn’t get away with it here. She imagined him coming from a barbarically foreign place, where he had harems of scantily clad women attending to his every need, and where he lounged on plush velvet and silk cushions in lavish tents in oases in the desert, gorging himself on ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("decadent foods and wines. The man clearly believed himself important enough to merit bringing bodyguards to a quiet and rural part of Ireland.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her overblown imagination mocked her as she recalled the sliver of hard, olive-skinned, muscle-ridged belly she’d seen as he’d vaulted onto Devil’s Kiss, when his shirt had ridden up for a moment. He didn’t have the body of a louche decadent, and he didn’t strike her as the kind of man who required protecting. Her belly tightened again, and a disturbing pulse throbbed between her legs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She entered the stableyard and tore off her cap, releasing her hair, breathing hard. Damp sweat pooled uncomfortably between her breasts and trickled down her back. She knew they’d been fighting a losing battle for some time, and that the culmination of it was today. And she knew rationally that she had no real reason to feel such antipathy towards this Sheikh other than the fact he happened to be the new owner…and that he disturbed her on a level she didn’t like to think about.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she looked around the unbearably shabby yard the fight suddenly left her, and she felt overwhelmed with fatigue and grief at seeing all the empty stalls. The stud down the road was equally desolate-looking. The homestead stood to the right of the yard. Once it had gleamed from top to bottom, a grand country house, but now it was a mere shadow of its former self. Everything was peeling and crumbling. She’d worked so hard to try and keep them afloat, but everything had gone against them—not least the global economic crisis.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("They might have won two prestigious races recently, but that money had barely made a dent in the huge debts that had built up from years of mismanagement. The one ace up their sleeve had been Devil’s Kiss, and now he was gone. Quite literally. The Sheikh had come to transport ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("him to his own country on the Arabian peninsula, where he had plans to train him, race him, and eventually use him to breed even more winners to add to his arsenal. He was going to overhaul their small stud farm and gallops and turn them into something homogenous: a conveyor belt outfit that would ‘perform’ and meet ‘targets’, and make a profit and breed winners.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("While Iseult had no problem with expansion, and turning their property around so that it functioned properly again on all levels, she’d always loved the fact that they’d remained true to their own identity long after many other farms had sold out to rich Arabs and huge syndicates. Now they were no different from the rest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Desultorily, Iseult made her way to Devil’s Kiss’s stable, to get it prepared for his return. She grimaced as she turned on a hose and started to sluice down the yard, thinking of her beloved grandfather, who would have railed against this day too… She’d followed him everywhere until his death; she’d been ten when he’d been struck down with an awful illness and everything had started to unravel…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Iseult diverted her mind away from painful memories. As soon as Devil’s Kiss had raced and shown his pedigree as a stunning two-year-old the spotlight had been turned onto their stud—especially as it had been so long since they’d produced a winner. Everyone knew that their backs were against the wall, and that they’d sold all but their oldest mares to concentrate on Devil’s Kiss. That buzz was undoubtedly what had brought them to the attention of the Sheikh. And Iseult had to admit bitterly that he’d snapped them up like the bargain they were.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("Ridiculously, tears threatened again—too much buried grief swimming up to the surface. And that was when Iseult heard the familiar clatter of hooves in the yard behind her. She hurriedly blinked away her tears and turned around ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("warily to look up. The sun chose that moment to peek out from dark, oppressive clouds and Iseult shivered—because she was momentarily blinded and all she could see was the intimidatingly broad-shouldered silhouette of the Sheikh on Devil’s back. Like a portent of doom.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("For a second Nadim was utterly transfixed. The girl was revealed fully without that unflattering cap, and she was most definitely a girl—beautiful enough to make his breath catch. Not a scrap of make-up marred her pale alabaster skin and that amazing bone structure. And he’d never seen such unusual colouring: long dark red hair was pulled back into an untidy ponytail which must have been stuffed under the cap, and tendrils drifted and clung to her cheeks and neck. Tight jeans and the fleece did little to disguise the fact that she was tall and slim, lean as a whip, her body sleek and toned.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But it was her eyes that caught him as if spellbound. Huge and almond shaped, with long black lashes, they were the colour of dark liquid amber. And as he watched, fascinated, those stunning eyes flashed a warning and her chest rose and fell, making him want to drop his gaze and inspect those delicately feminine swells again. He sensed instinctively that she was more voluptuous than she looked, and wondered why she hid her curves. But he cut off his wandering mind there, when it had a direct effect on his anatomy. The kick of desire in his blood made him feel disorientated. It was unwarranted and completely inappropriate.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her full mouth had tightened back into the mutinous line. ‘If you’ve quite finished your inspection, I’ll take Devil’s Kiss now. I’m not part of the inventory of your newly acquired assets.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("Her voice was surprisingly husky, but Nadim didn’t dwell ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("on that further enticement now. Her haughty look forced a surge of anger upward and drove Nadim off the horse to the ground. Once again he’d been mesmerised by someone who was little more than a stablehand. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Unthinkable")]), _vm._v(". He deliberately ignored her hand, outstretched for the reins, fixing her with a harsh glare.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was a struggle for Iseult to stay standing as the Sheikh came off the horse and stood far too close for her liking. His slow appraisal just now had turned her insides to jelly. And now, facing her like this, he was far more devastating than she’d acknowledged before. He had to be at least six foot three and, while she was relatively tall, she felt minute in comparison.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Correct me if I’m wrong, Miss O’Sullivan, but I believe that you and your father are very much part of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("inventory")]), _vm._v(". Part of the agreement for the sale of this property outlines the fact that all working staff will be retained to ensure a smooth transition. Are you not part of the staff?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His deep voice and softly drawled words, with more than a hint of a seductively foreign accent, made Iseult’s knees feel curiously weak. Anger at her response made her lash out. ‘I’m more than just staff. Perhaps where you come from you’re used to buying and selling people, but in this country we’ve outgrown such antiquated practices.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His face tightened perceptibly. ‘Be very careful, Miss O’Sullivan. You’re in danger of going too far. As it is, your insolence is intolerable. I don’t appreciate "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("employees")]), _vm._v(" who talk back or use guard dogs to intimidate.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Iseult flushed at being reminded of the recent incident with his emissary. ‘Murphy isn’t a guard dog. He’s just protective. Your assistant was trespassing; I was here on my own.’")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("The Sheikh’s mouth was a grim line of displeasure. ‘You ignored a perfectly polite request from him to come and ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("see the property even though it was common knowledge you were close to advertising a sale.’")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Iseult couldn’t meet that blistering dark gaze. She felt about two feet tall. How could she explain to this autocratic man the violently visceral feeling she’d had not to give up and admit defeat? And how his arrogant assistant had effortlessly raised her hackles by being so pushy, making her dread a soulless takeover by a face less buyer?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He continued, ‘Do I need to remind you that very soon I will own everything you see around you, and could have you thrown off this property for good?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Iseult could feel the colour drain from her face, and saw something flash in his eyes. He even said something that sounded like a curse under his breath and moved towards her. Did he think she was going to faint? Iseult had never fainted in her life. She moved back jerkily, and the Sheikh stopped, his eyes gleaming obsidian.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nadim had to curb a reflex to apologise—although he couldn’t remember the last time he’d had to apologise for anything. He hadn’t meant to speak so harshly, but when she’d gone white and looked as if he’d put a knife through her heart his immediate reaction had been one of remorse and to protect. He couldn’t believe that this girl had taken him in even for a moment. He allowed no woman to get under his skin so easily.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shouldn’t be demeaning himself by engaging in dialogue with someone like her. She was about to become just one more of hundreds of employees scattered across the globe.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He finally handed her the reins and said curtly, ‘Devil’s Kiss travels tomorrow. See to it that he’s ready.’")])])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page21"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2265f466","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459201859_ch01.vue
// module id = 78
// module chunks = 0